import axios from 'src/app-axios';
import Constants from 'src/constants';
import moment from 'moment';

export const swiftuser = {
  namespaced: true,
  state: {
    visitPurpose: null,
    qrCodeDetails: null,
    locationName: {},
    allJobs: [],
    selectedWorkDetails: {},
    checkInId: {},
    issueStatus: {},
    activeCheckInDetails: {},
    visitStatus: {},
    WorkTimerLastUpdatedAt: '',
    breakTimerLastUpdatedAt: '',
    workerDocVerificationStatus: {},
    uploadedDocs: [],
    manualCheckoutDetails: {},
    checkoutType: 'qrScan',
    selectedInstanceDetails: null,
    selectedContractDetails: {},
    contractProgress: null,
    projectProgress: null,
    previousCheckInDetails: {},
    checkInMethodType: null,
    checkOutMethodType: null,
    appUserActvities: {},
    showOvertimeButtonStatus: false,
    workLogs: [],
  },
  getters: {
    getVisitPurpose (state) {
      return state.visitPurpose;
    },
    getQrCodeDetails (state) {
      return state.qrCodeDetails;
    },
    getLocationName (state) {
      return state.locationName;
    },
    getAllJobs (state) {
      return state.allJobs;
    },
    getSelectedWorkDetails (state) {
      return state.selectedWorkDetails;
    },
    getCheckInId (state) {
      return state.checkInId;
    },
    getIssueStatus (state) {
      return state.issueStatus;
    },
    getActiveCheckInDetails (state) {
      return state.activeCheckInDetails;
    },
    getVisitStatus (state) {
      return state.visitStatus;
    },
    getWorkTimerUpdatedAt (state) {
      return state.WorkTimerLastUpdatedAt;
    },
    getBreakTimerUpdatedAt (state) {
      return state.breakTimerLastUpdatedAt;
    },
    getWorkerDocVerifyStatus (state) {
      return state.workerDocVerificationStatus;
    },
    getUploadedDocs (state) {
      return state.uploadedDocs;
    },
    getManualCheckoutDetails (state) {
      return state.manualCheckoutDetails;
    },
    getCheckoutType (state) {
      return state.checkoutType;
    },
    getSelectedInstanceDetails (state) {
      return state.selectedInstanceDetails;
    },
    getSelectedContractDetails (state) {
      return state.selectedContractDetails;
    },
    getContractProgress (state) {
      return state.contractProgress;
    },
    getProjectProgress (state) {
      return state.projectProgress;
    },
    getPreviousCheckInDetails (state) {
      return state.previousCheckInDetails;
    },
    getCheckInMethodType (state) {
      return state.checkInMethodType;
    },
    getCheckOutMethodType (state) {
      return state.checkOutMethodType;
    },
    getAppUserActivities (state) {
      return state.appUserActvities;
    },
    getOvertimeButtonStatus (state) {
      return state.showOvertimeButtonStatus;
    },
    getWorkLogs (state) {
      return state.workLogs;
    },
  },
  actions: {
    async verifyLocation ({ commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/check-in/site-verify`;
      const response = await axios.post(url, payload.details);
      commit('setLocationName', response.data);
    },
    async verifyDocuments ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.organizationExtId}/documents-verify`;
      try {
        const status = await axios.post(url);
        commit('setWorkerDocVerifyStatus', status.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in verifying your documents.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async verifyWorkDetails ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.organizationExtId}/check-in/budget-verify`;
      try {
        await axios.post(url, payload.details);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in verifying the work details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async checkInUser ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/app-users/checkin`;
      try {
        const response = await axios.post(url, payload.details);
        commit('setCheckInId', response.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in check-in you to this location.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    saveVisitPurpose (context, details) {
      context.commit('setVisitPurpose', details);
    },
    onQrCodeScan (context, details) {
      context.commit('setQrCodeDetails', details);
    },
    saveSelectedWorkDetails (context, details) {
      context.commit('setSelectedWorkDetails', details);
    },
    async sendWorkDetails ({ dispatch }, payload) {
      const url = `api/devices/check-in/${payload.checkInId}/worker`;
      try {
        await axios.post(url, payload.details);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in sending your your work details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async sendVisitDetails ({ dispatch }, payload) {
      const url = `api/devices/check-in/${payload.checkInId}/visitor`;
      try {
        await axios.post(url, payload.purpose);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in sending your your visit purpose details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    saveIssueStatus (context, details) {
      context.commit('setIssueStatus', details);
    },
    clearActiveCheckInDeatils ({ commit }) {
      commit('clearActiveCheckIn');
    },
    async fetchActiveCheckInDetails ({ dispatch, commit, state }, payload) {
      if (Object.keys(state.activeCheckInDetails).length > 0) {
        return;
      }
      const url = `api/devices/check-in/${payload.attendenceId}`;
      try {
        const details = await axios.get(url);
        commit('setActiveCheckInDetails', details.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the active check-in details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
    async fetchAppUserActivities ({ dispatch, commit, state }, payload) {
      if (Object.keys(state.activeCheckInDetails).length > 0) {
        return;
      }
      const url = `api/devices/app-users/${payload.attendenceId}/activities`;
      try {
        const details = await axios.get(url, payload.params);
        commit('setAppUserActivities', details.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the active check-in details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
    async checkOutUser ({ dispatch }, payload) {
      const url = `api/devices/check-out/${payload.checkInId}`;
      try {
        await axios.post(url, payload.checkOutTime);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in check-out you from this location.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async sendIssueStatus ({ dispatch }, payload) {
      const url = `api/devices/check-out/${payload.checkInId}/worker`;
      try {
        await axios.post(url, payload.statusDetails);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in sending your work status.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    saveVisitStatus (context, details) {
      context.commit('setVisitStatus', details);
    },
    async sendVisitStatus ({ dispatch }, payload) {
      const url = `api/devices/check-out/${payload.checkInId}/visitor`;
      try {
        await axios.post(url, payload.statusDetails);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in sending your job status.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    updateWorkTimer ({ commit }) {
      commit('setWorkTimerUpdatedAt', moment().toISOString());
    },
    updateBreakTimer ({ commit }) {
      commit('setBreakTimerUpdatedAt', moment().toISOString());
    },
    clearWorkerDocVerifyStatus (context) {
      context.commit('removeWorkerDocVerifyStatus');
    },
    async fetchUploadedDocs ({ dispatch, commit }) {
      const url = 'api/devices/documents';
      try {
        const docs = await axios.get(url);
        commit('setUploadedDocs', docs.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in fetching your uploaded documents list.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
    clearScannedLocationName (context) {
      context.commit('removeScannedLocationName');
    },
    saveManualCheckoutDetails (context, reason) {
      context.commit('setManualCheckoutDetails', reason);
    },
    saveCheckoutType (context, type) {
      context.commit('setCheckoutType', type);
    },
    clearManualCheckoutDetails (context) {
      context.commit('removeManualCheckoutDetails');
    },
    async fetchUsersCurrentCheckInDetails ({ dispatch, commit, state }) {
      const url = 'api/devices/app-users/user-active-records';
      try {
        const details = await axios.get(url);
        commit('setActiveCheckInDetails', details.data);
        localStorage.setItem('userActiveRecord', JSON.stringify(details.data));
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the active check-in details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
    saveSelectedInstanceDetails (context, details) {
      context.commit('setSelectedInstanceDetails', details);
    },
    saveSelectedContractDetails (context, details) {
      context.commit('setSelectedContractDetails', details);
    },
    async verifyContractDetails ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.organizationExtId}/check-in/contract-verify`;
      try {
        await axios.post(url, payload.contractId);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in verifying the contract details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async sendContractDetails ({ dispatch }, payload) {
      const url = `api/devices/check-in/${payload.checkInId}/contractor`;
      try {
        await axios.post(url, payload.details);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in sending your your contract details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    saveContractProgress (context, value) {
      context.commit('setContractProgress', value);
    },
    async sendContractProgress ({ dispatch }, payload) {
      const url = `api/devices/check-out/${payload.checkInId}/contractor`;
      try {
        await axios.post(url, payload.contractProgress);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in sending your contract progress.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    saveProjectProgress (context, value) {
      context.commit('setProjectProgress', value);
    },
    async sendProjectProgress ({ dispatch }, payload) {
      const url = `api/devices/check-out/${payload.checkInId}/staff`;
      try {
        await axios.post(url, payload.projectProgress);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in sending your project progress.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    clearSavedWorkDetails (context) {
      context.commit('clearWorkDetails');
    },
    clearSavedContractDetails (context) {
      context.commit('clearContractDetails');
    },
    async fetchPreviousCheckInDetails ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.orgExtId}/records/app-user/latest`;
      try {
        const details = await axios.get(url);
        commit('setPreviousCheckInDetails', details.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in fetching your latest check-in record.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
    storeCheckInMethodType (context, payload) {
      context.commit('setCheckInMethodType', payload.type);
    },
    storeCheckOutMethodType (context, payload) {
      context.commit('setCheckOutMethodType', payload.type);
    },
    async startOvertime ({ dispatch }, payload) {
      const url = `api/devices/check-in/${payload.checkInId}/overtime`;
      try {
        await axios.post(url, payload);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message: 'Something went wrong in sending your project progress.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        throw exception;
      }
    },
    async fetchWorkLogs ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/work-logs`;
      try {
        const details = await axios.get(url);
        commit('setWorkLogs', details.data);
      } catch (exception) {
        dispatch(
          'alert/onAlert',
          {
            message:
              'Something went wrong in getting the active check-in details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }
    },
  },
  mutations: {
    setVisitPurpose (state, data) {
      state.visitPurpose = data;
    },
    setQrCodeDetails (state, data) {
      state.qrCodeDetails = data;
    },
    setLocationName (state, name) {
      state.locationName = name;
    },
    setAllJobs (state, data) {
      state.allJobs = data;
    },
    setSelectedWorkDetails (state, data) {
      state.selectedWorkDetails = data;
    },
    setCheckInId (state, details) {
      state.checkInId = details;
    },
    setIssueStatus (state, data) {
      state.issueStatus = data;
    },
    setActiveCheckInDetails (state, data) {
      state.activeCheckInDetails = data;
    },
    setAppUserActivities (state, data) {
      state.appUserActvities = data.data;
    },
    clearActiveCheckIn (state, data) {
      state.activeCheckInDetails = {};
    },
    setVisitStatus (state, data) {
      state.visitStatus = data;
    },
    setWorkTimerUpdatedAt (state, dateTime) {
      state.WorkTimerLastUpdatedAt = dateTime;
    },
    setBreakTimerUpdatedAt (state, dateTime) {
      state.breakTimerLastUpdatedAt = dateTime;
    },
    setWorkerDocVerifyStatus (state, status) {
      state.workerDocVerificationStatus = status;
    },
    removeWorkerDocVerifyStatus (state) {
      state.workerDocVerificationStatus = {};
    },
    setUploadedDocs (state, docs) {
      state.uploadedDocs = docs;
    },
    removeScannedLocationName (state) {
      state.locationName = {};
    },
    setManualCheckoutDetails (state, details) {
      state.manualCheckoutDetails = details;
    },
    setCheckoutType (state, type) {
      state.checkoutType = type;
    },
    removeManualCheckoutDetails (state) {
      state.manualCheckoutDetails = {};
    },
    setSelectedInstanceDetails (state, details) {
      state.selectedInstanceDetails = details;
    },
    setSelectedContractDetails (state, details) {
      state.selectedContractDetails = details;
    },
    setContractProgress (state, value) {
      state.contractProgress = value;
    },
    setProjectProgress (state, value) {
      state.projectProgress = value;
    },
    clearWorkDetails (state) {
      state.selectedWorkDetails = {};
      state.selectedInstanceDetails = null;
    },
    clearContractDetails (state) {
      state.selectedContractDetails = {};
    },
    setPreviousCheckInDetails (state, details) {
      state.previousCheckInDetails = details;
    },
    setCheckInMethodType (state, type) {
      state.checkInMethodType = type;
    },
    setCheckOutMethodType (state, type) {
      state.checkOutMethodType = type;
    },
    setWorkLogs (state, logs) {
      state.workLogs = logs;
    },
  },
};
